import TopScanCitiesPanel from "./topScanCitiesPanel.container";

export default TopScanCitiesPanel;
